import React from "react";
import ReactDOM from "react-dom/client";

import { Datetime } from "@app/scripts/react-datetime/components/Datetime";

const DatetimeElem = class extends HTMLElement {
  connectedCallback() {
    const label = this.getAttribute("label");
    const name = this.getAttribute("name");

    const root = ReactDOM.createRoot(this);
    root.render(<Datetime name={name} label={label} />);
  }
};

customElements.define("ui-datetime", DatetimeElem);
